import React from "react";

// Superscript "new" chip for flagging a recently shipped feature. Place one on
// each level of navigation that leads to the feature, so the trail cascades.
// Renders as <sup>, so keep the parent's layout inline (not flex-centered).
const NewBadge = () => (
  <sup className="ml-0.5 inline-flex items-center justify-center rounded-full bg-primary px-1 py-0.5 text-[8px] font-semibold leading-none text-white">
    new
  </sup>
);

export default NewBadge;
